import { getters } from "ApproversLabel";

export const getLoadingApproval = (state, props = {}) =>
  Boolean(getters.loadingApproval(state, props)[props.id]);

export const getManifest = (state, props = {}) =>
  getters.manifests(state, props)[props.id];
